module.exports = __webpack_public_path__ + "static/media/tvshows-header.5fa0c855.svg";